export default __webpack_public_path__ + "static/media/theatre.60eca7a7.jpg";